module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_ SHIFTING EFFECT LEATHER_mobile.122b7a4a.jpg";